/* so-cart-addons — picker + add for the "Goes with your order" rows (drawer + /cart).
   Delegated from document because the drawer re-renders on every cart change.
   More than one in-stock variant → the PDP flavour drawer (so-variant-drawer styles), portalled to <body>.
   Pre-selects the option value already in the cart (e.g. the same flavour) when present.
   Adds are recorded in the hidden cart attribute _so_src (assets/so-cart-source.js; row's data-so-source,
   default cart-upsell; empty-cart rows cart-usual / cart-popular, the Reorder button cart-reorder) — never as
   line properties, so the same flavour added anywhere stays ONE line (P0-12). Read back from orders. */
(function () {
  if (window.soCartAddonsBound) return;
  window.soCartAddonsBound = true;

  // F2: one stock vocabulary (assets/so-stock-state.js, loaded in <head>).
  function soPreShip() { var s = window.SO && SO.stock ? SO.stock.shipText('pre', null, null, true) : ''; return s ? ' · ' + s : ''; }
  function soRowTag(qty, policy, notify, unit) {
    if (!(window.SO && SO.stock)) return qty > 0 ? 'In stock' : (policy === 'continue' ? 'Pre-order' : 'Out of stock');
    return SO.stock.label(SO.stock.classify({ tracked: true, policy: policy, qty: qty }, SO.stock.lowAt()), 'row', { notify: !!notify, unit: unit });
  }

  function data(row) {
    try { return JSON.parse(row.querySelector('[data-so-addon-json]').textContent); } catch (e) { return null; }
  }
  function cartValues() {
    var vals = {};
    document.querySelectorAll('.cart-item__variant-values').forEach(function (el) {
      el.textContent.split('·').forEach(function (s) { vals[s.trim().toLowerCase()] = true; });
    });
    return vals;
  }
  function preselect(variants, prefer) {
    for (var j = 0; prefer && j < variants.length; j++) if (variants[j].id === prefer) return variants[j];
    var vals = cartValues();
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options.some(function (o) { return vals[String(o).toLowerCase()]; })) return variants[i];
    }
    return variants[0];
  }

  // Immediate feedback: the tapped control says "Adding…", the row's + becomes a spinner, other
  // options lock (no double adds), and the sheet closes at once so the working row is visible.
  function add(row, variantId, btn, tapped) {
    if (!variantId || row.dataset.busy) return;
    row.dataset.busy = '1';
    row.classList.add('is-adding');
    if (tapped) { tapped.dataset.label = tapped.textContent; tapped.classList.add('is-adding'); tapped.textContent = 'Adding…'; tapped.setAttribute('aria-busy', 'true'); }
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-label', 'Adding to cart'); }
    closeSheet(true);
    post(row, [{ id: variantId, quantity: 1 }], row.dataset.soSource || 'cart-upsell')
      .catch(function (err) {
        delete row.dataset.busy;
        row.classList.remove('is-adding');
        if (tapped) { tapped.classList.remove('is-adding'); tapped.textContent = tapped.dataset.label || tapped.textContent; tapped.removeAttribute('aria-busy'); }
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
        var why = row.querySelector('.so-cart-addons__why');
        if (why) why.textContent = typeof err === 'string' ? err : 'Something went wrong. Please try again.';
      });
  }

  // Fresh drawer HTML rendered WITH the drawer's saved settings. Never request it by its bare name
  // (?section_id=cart-drawer): that renders schema DEFAULTS — vendor line, "Add order note", the
  // tax/shipping line (memory cart-drawer-section-group-trap). Use the section-group id; if the
  // Section Rendering API returns null for it, read the drawer out of a full page render.
  function drawerHtml(sid) {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      .then(function (j) {
        if (j && j[sid]) return j[sid];
        return fetch(window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'so_drawer=' + Date.now())
          .then(function (r) { return r.text(); });
      });
  }

  // POST lines to /cart/add.js and refresh the drawer in place (or reload /cart). Rejects with a message.
  // source: recorded in _so_src for every line once the add succeeded (P0-12); the reload path waits for it.
  function post(el, items, source) {
    var cd = document.querySelector('cart-drawer');
    var inDrawer = !!el.closest('cart-drawer');
    var sid = cd && cd.closest('.shopify-section') ? cd.closest('.shopify-section').id.replace('shopify-section-', '') : '';
    var sections = 'cart-icon-bubble' + (sid ? ',' + sid : '');
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
      .then(function (r) {
        if (!r.ok) throw (r.body && (r.body.description || r.body.message)) || 'Could not add to cart.';
        var rec = source && window.SO && SO.cartSource
          ? Promise.all(items.map(function (it) { return SO.cartSource.record(it.id, source, '', it.quantity); }))
          : Promise.resolve();
        if (!(inDrawer && cd && cd.renderContents && r.body.sections)) { return rec.then(function () { window.location.reload(); }); }
        // The Section Rendering API can return null for the drawer (a section-group member) — seen on
        // an empty → filled drawer. The theme's own fallback reads /cart, which has no drawer.
        if (sid && !r.body.sections[sid]) {
          return drawerHtml(sid).then(function (html) { r.body.sections[sid] = html; cd.renderContents(r.body, false); }).then(redraw);
        }
        cd.renderContents(r.body, false);
        return redraw();
        // Review B1: so-cart-addons.liquid reads cart-upsell from _so_src, and the render above predates the
        // write. For cart-upsell (the only source the Liquid reads) draw the drawer once more after it lands.
        function redraw() {
          if (source !== 'cart-upsell' || !sid) return;
          return rec.then(function () { return drawerHtml(sid); }).then(function (html) {
            var b = { sections: {} }; b.sections[sid] = html; cd.renderContents(b, false);
          });
        }
      });
  }

  // Empty cart "Reorder": every in-stock line of the last order in one request.
  function reorder(btn) {
    if (btn.dataset.busy) return;
    var items;
    try { items = JSON.parse(btn.parentNode.querySelector('[data-so-reorder-json]').textContent); } catch (e) { return; }
    if (!items.length) return;
    btn.dataset.busy = '1';
    btn.dataset.label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.classList.add('is-adding');
    btn.setAttribute('aria-busy', 'true');
    post(btn, items, 'cart-reorder').catch(function (err) {
      delete btn.dataset.busy;
      btn.classList.remove('is-adding');
      btn.removeAttribute('aria-busy');
      btn.textContent = btn.dataset.label;
      var note = document.createElement('p');
      note.className = 'so-cart-empty__note';
      note.textContent = typeof err === 'string' ? err : 'Something went wrong. Please try again.';
      btn.after(note);
    });
  }

  // Variant picker = the PDP flavour drawer (so-variant-drawer.css): right-side drawer on desktop,
  // bottom sheet on phones, thumbnail rows with stock counts, search when >6. Only in-stock
  // variants are listed; tapping a row adds it. The row we'd pick (same flavour as the cart /
  // their usual) sits first with the selected ring.
  var sheet = null, sheetOpener = null;
  function closeSheet(keepFocus) {
    if (!sheet) return;
    var s = sheet; sheet = null;
    s.drawer.classList.remove('is-open'); s.backdrop.classList.remove('is-open');
    setTimeout(function () { s.root.remove(); }, 260);
    document.documentElement.style.overflow = '';
    if (!keepFocus && sheetOpener && sheetOpener.isConnected) sheetOpener.focus();
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  // Phones: swipe down to close (shared assets/so-sheet-swipe.js; the ::before grab bar is the affordance).
  function swipe(s) {
    if (window.soSheetSwipe) window.soSheetSwipe.attach(s.drawer, { handle: '.so-vd__header', scroller: '.so-vd__list', backdrop: s.backdrop, onClose: function () { if (sheet === s) closeSheet(); } });
  }
  // Task 21 focus policy (same as so-postcode.js focusTarget): a sheet may focus its search field on open only
  // with a fine pointer that can hover; touch (coarse pointer, or no hover) gets the drawer/heading, no keyboard.
  function finePointer() {
    var mq = function (q) { try { return !!(window.matchMedia && window.matchMedia(q).matches); } catch (e) { return false; } };
    return !(mq('(pointer: coarse)') || mq('(hover: none)'));
  }
  function showSheet(row, d, btn) {
    closeSheet(true);
    var pick = preselect(d.variants, d.prefer);
    var low = window.SO && SO.stock ? SO.stock.lowAt() : (parseInt((row.closest('[data-threshold-low]') || {}).dataset ? row.closest('[data-threshold-low]').dataset.thresholdLow : '', 10) || 0);
    var optName = String((d.options && d.options[0] && (d.options[0].name || d.options[0])) || 'option').toLowerCase();
    sheetOpener = btn;
    var root = document.createElement('div');
    root.className = 'so-cart-addons-vd';
    root.innerHTML =
      '<div class="so-vd__backdrop" data-close></div>' +
      '<div class="so-vd__drawer" role="dialog" aria-modal="true" tabindex="-1" aria-label="Choose your ' + esc(optName) + '">' +
      '<header class="so-vd__header"><div class="so-vd__header-text"><h2 class="so-vd__title">Choose your ' + esc(optName) + '</h2>' +
      '<p class="so-vd__summary">' + esc(d.title) + ' · tap one to add it</p></div>' +
      '<button type="button" class="so-vd__close" data-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg></button></header>' +
      (d.variants.length > 6 ? '<div class="so-vd__search-wrap"><input type="search" class="so-vd__search" placeholder="Search ' + esc(optName) + '…" aria-label="Search ' + esc(optName) + '" autocomplete="off"></div>' : '') +
      '<ul class="so-vd__list" role="listbox"></ul><p class="so-vd__noresults" hidden>No matches — try another search.</p></div>';
    var list = root.querySelector('.so-vd__list');
    var ordered = pick ? [pick].concat(d.variants.filter(function (v) { return v !== pick; })) : d.variants;
    ordered.forEach(function (v) {
      var li = document.createElement('li');
      li.className = 'so-vd__row' + (v === pick ? ' is-selected' : '');
      li.setAttribute('role', 'option'); li.tabIndex = 0;
      var tag = '';
      if (typeof v.stock === 'number') {
        // F2 I1: v.cont (continue_selling policy) is carried through the JSON so this reads the
        // real per-variant policy instead of a hard-coded 'deny'.
        tag = soRowTag(v.stock, v.cont ? 'continue' : 'deny', false, d.unit);
        li.classList.add(low && v.stock <= low ? 'is-lowstock' : 'is-instock');
      }
      li.innerHTML = '<span class="so-vd__thumb">' + (v.img ? '<img src="' + esc(v.img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="so-vd__thumb-fallback" aria-hidden="true"></span>') + '</span>' +
        '<span class="so-vd__row-text"><span class="so-vd__row-name">' + esc(v.title) + '</span><span class="so-vd__row-tag"' + (tag ? '' : ' hidden') + '>' + esc(tag) + '</span></span>' +
        '<span class="so-vd__row-check" aria-hidden="true"></span>';
      function go() {
        if (row.dataset.busy) return;
        li.classList.add('is-selected');
        var t = li.querySelector('.so-vd__row-tag'); t.hidden = false; t.textContent = 'Adding…';
        add(row, v.id, btn, null);
      }
      li.addEventListener('click', go);
      li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      list.appendChild(li);
    });
    var search = root.querySelector('.so-vd__search');
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase(), n = 0;
      list.querySelectorAll('.so-vd__row').forEach(function (li) { var hit = !q || li.textContent.toLowerCase().indexOf(q) !== -1; li.hidden = !hit; if (hit) n++; });
      root.querySelector('.so-vd__noresults').hidden = n > 0;
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeSheet(); });
    document.body.appendChild(root);
    sheet = { root: root, drawer: root.querySelector('.so-vd__drawer'), backdrop: root.querySelector('.so-vd__backdrop') };
    swipe(sheet);
    document.documentElement.style.overflow = 'hidden';
    void sheet.drawer.offsetWidth; // forced reflow, then slide in (rAF is throttled in some browsers)
    sheet.drawer.classList.add('is-open'); sheet.backdrop.classList.add('is-open');
    // Phones: don't pop the keyboard over the flavour list — focus the drawer; mouse devices get search.
    ((finePointer() && search) || sheet.drawer).focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    // Your-picks link (so-mail format): ?o=<variantId base36>[-qty].… — repeats merged (qty summed),
    // qty 1–99, max 6 lines, no personal data.
    var pk = e.target.closest && e.target.closest('a[data-so-picks]');
    if (pk) {
      var qty = {}, order = [];
      pk.dataset.soPicks.split(',').filter(Boolean).forEach(function (x) {
        var p = x.split(':');
        if (!(p[0] in qty)) { qty[p[0]] = 0; order.push(p[0]); }
        qty[p[0]] += parseInt(p[1], 10) || 1;
      });
      var o = order.slice(0, 6).map(function (id) {
        var q = Math.min(99, Math.max(1, qty[id]));
        return Number(id).toString(36) + (q > 1 ? '-' + q : '');
      });
      pk.href = '/pages/your-picks?o=' + o.join('.') + '&src=cart'; // page tags its adds _source: your-picks, _via: cart
      return;
    }
    var ro = e.target.closest && e.target.closest('[data-so-reorder]');
    if (ro) { e.preventDefault(); reorder(ro); return; }
    var btn = e.target.closest && e.target.closest('[data-so-addon-add]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('.so-cart-addons__row');
    var d = row && data(row);
    if (!d || !d.variants.length) return;
    if (d.variants.length === 1) add(row, d.variants[0].id, btn);
    else showSheet(row, d, btn);
  });
  // Quantity changes / removals re-render only the cart lines (cart-items.js), so the add-ons block
  // (suggestions, "R{n} off delivery" notes, open state) would go stale. On on:line-item:change,
  // re-fetch the section and swap in the fresh block (or drop it when nothing qualifies any more).
  // Mixed pre-order carts: the "R{n} off delivery" lines are rendered for the full cart
  // (data-so-ca-basis="all") and for the in-stock items only ("shipnow"). Show the set matching
  // the pre-order choice — "Remove the pre-order items" trims the cart at checkout (same rule as
  // the delivery row in so-cart-delivery.js).
  function applyBasis() {
    var r = document.querySelector('.so-preorder-cart__radio:checked');
    var shipnow = !!(r && r.value === 'shipnow');
    document.querySelectorAll('[data-so-ca-basis]').forEach(function (el) {
      el.hidden = shipnow ? el.getAttribute('data-so-ca-basis') !== 'shipnow' : el.getAttribute('data-so-ca-basis') !== 'all';
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('so-preorder-cart__radio')) applyBasis();
  });

  function ensureStyles(from) {
    var have = {};
    document.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) { have[l.href.split('?')[0]] = 1; });
    from.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) {
      // P0-11: resolve the attribute against the page (a link inside an inert <template> has no base URL).
      var abs; try { abs = new URL(l.getAttribute('href'), location.href); } catch (e) { return; }
      var k = abs.href.split('?')[0];
      if (have[k] || !/\/so-[\w-]+\.css$/.test(k)) return;
      if (abs.origin !== location.origin) return;   // same-origin (Shopify CDN path on our domain) only
      have[k] = 1;
      var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = abs.href;
      document.head.appendChild(n);
    });
  }

  // P0-11: the fresh block comes from the change response itself when it carries this section (cart-items.js and
  // so-cart-optimistic.js ask for it and pass the response, sections included, as e.detail.cart), so the add-ons
  // change in the same frame as the lines. Only when that section is missing is it fetched again.
  function sectionFrom(cart, sid) {
    var h = cart && cart.sections && cart.sections[sid];
    return typeof h === 'string' && h ? h : null;
  }

  var refreshSeq = 0;
  document.addEventListener('on:line-item:change', function (e) {
    var items = e.target && e.target.closest ? e.target.closest('cart-items') || e.target : null;
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = !!(items && items.closest && items.closest('cart-drawer'));
    var host = inDrawer ? drawer : items && items.closest ? items.closest('.shopify-section') : null;
    var sec = host && (inDrawer ? host.closest('.shopify-section') : host);
    if (!sec) return;
    var seq = ++refreshSeq;
    var sid = sec.id.replace('shopify-section-', '');
    var given = sectionFrom(e.detail && e.detail.cart, sid);
    var get = given != null ? Promise.resolve(given)
      : inDrawer ? drawerHtml(sid)
      : fetch(window.location.pathname + '?section_id=' + sid).then(function (r) { return r.text(); });
    get.then(function (html) {
      if (seq !== refreshSeq) return; // a newer change is already on its way
      var tmp = document.createElement('template'); tmp.innerHTML = html;   // inert: the section's images don't load
      var fresh = tmp.content.querySelector('details.so-cart-addons');
      // Task 30: we swap only the <details>, so carry over any stylesheet the fresh render links that
      // this page doesn't have yet (else the block is inserted unstyled).
      if (fresh) ensureStyles(tmp.content);
      if (fresh) fresh = document.importNode(fresh, true);
      var scope = inDrawer ? drawer : sec;
      var old = scope.querySelector('details.so-cart-addons');
      if (old && fresh) old.replaceWith(fresh);
      else if (old) old.remove();
      else if (fresh) {
        var anchor = inDrawer ? scope.querySelector('#cart-drawer-form') : scope.querySelector('cart-items');
        if (anchor) anchor.after(fresh);
      }
      applyBasis();
    }).catch(function () {});
  });

  // Escape closes only our sheet: cart-drawer.js closes the cart on Escape KEYUP, so swallow the
  // keyup that follows. Tab / Shift+Tab stay inside the sheet (it is a modal dialog).
  var swallowEscUp = false;
  document.addEventListener('keydown', function (e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); swallowEscUp = true; closeSheet(); return; }
    if (e.key === 'Tab') {
      var f = [].filter.call(sheet.drawer.querySelectorAll('button, input, [tabindex="0"]'), function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !sheet.drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !sheet.drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && swallowEscUp) { e.stopPropagation(); e.preventDefault(); swallowEscUp = false; }
  }, true);

  // ---------------------------------------------------------------------------------------------
  // "Change" on a cart line (snippets/so-cart-change.liquid): the product-page flavour drawer,
  // then an in-place swap with the Storefront API. cartLinesUpdate changes the line's variant and
  // keeps its position and quantity; its _so_src attribution is moved to the new variant (P0-12). The AJAX cart can't do that — it can
  // only remove + add, which moves the line. Public token = the one in sections/so-for-you.liquid.
  // Spec: docs/superpowers/specs/2026-09-24-cart-change-flavour-design.md (smoke-organic repo).
  var SF_TOKEN = '9f1a3cff0634491b892a6132ddc958c1';
  function changeLow() { return window.SO && SO.stock ? SO.stock.lowAt() : 9; } // F2: one threshold (theme setting)
  function sf(query, variables) {
    return fetch('/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.errors && d.errors.length) throw d.errors[0].message;
      return d.data;
    });
  }
  // The cart token is in the `cart` cookie; /cart.js is the fallback (one request slower).
  function cartToken() {
    var m = document.cookie.match(/(?:^|; )cart=([^;]+)/);
    if (m) return Promise.resolve(decodeURIComponent(m[1]));
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { return c.token; });
  }
  function gidV(id) { return 'gid://shopify/ProductVariant/' + id; }
  var FLASH_KEY = 'soCartChangeFlash';
  var STALE = 'Your cart changed in another tab, so we refreshed it. Please try again.';

  // One permanent polite live region; text is set a beat later so screen readers announce it.
  function announce(text) {
    var live = document.getElementById('so-cart-change-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'so-cart-change-live';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 120);
  }

  // Other cart lines already holding variant id (all of them, not just one).
  function otherRows(scope, id, line) {
    var rows = [];
    scope.querySelectorAll('.cart-item[data-variant-id="' + id + '"]').forEach(function (row) {
      var n = parseInt((row.id || '').replace('cart-item-', ''), 10);
      var q = row.querySelector('input[name="updates[]"]');
      if (n && n !== line) rows.push({ line: n, qty: q ? parseInt(q.value, 10) || 0 : 0 });
    });
    return rows;
  }
  // Final quantity + stock/pre-order wording for "want" units of v (want already includes merges).
  function stockPlan(d, v, want) {
    var p = { qty: want, tag: '', kind: 'in' };
    var tracked = typeof v.stock === 'number';
    var u = d.unit === 'packs' ? ' packs' : ''; // F2 R2: packs noun (ZYN etc.)
    if (!v.available) { p.kind = 'out'; p.tag = 'Out of stock'; return p; }
    if (tracked && v.stock <= 0) { p.kind = 'pre'; p.tag = ''; } // group header carries the ship date
    else if (tracked && v.stock < want) {
      if (v.cont) { p.kind = 'pre'; p.tag = 'Only ' + v.stock + u + ' left · ' + (want - v.stock) + ' of your ' + want + ' on pre-order'; }
      else { p.kind = 'low'; p.qty = v.stock; p.tag = 'Only ' + v.stock + u + ' left · your ' + want + ' becomes ' + v.stock; }
    } else if (tracked && v.stock <= changeLow()) {
      p.kind = 'low';
      // F2 I1: continue-policy low stock reads the same vocabulary as the PDP/drawer, not the
      // deny "Only N left" scarcity wording.
      p.tag = v.cont ? v.stock + u + ' in stock · more on pre-order' : 'Only ' + v.stock + u + ' left';
    } else if (tracked) { p.tag = 'In stock'; }
    return p;
  }
  function changePlan(d, v, scope) {
    var others = otherRows(scope, v.id, d.line);
    var extra = others.reduce(function (a, o) { return a + o.qty; }, 0);
    var p = stockPlan(d, v, d.qty + extra);
    if (others.length && p.kind !== 'out') p.tag = 'Already in your cart (' + extra + ') · we’ll combine them' + (p.tag ? ' · ' + p.tag : '');
    return p;
  }

  var changing = false;
  function setChanging(on) {
    changing = on;
    document.documentElement.classList.toggle('so-cart-changing', on);
    document.querySelectorAll('[data-so-cart-change]').forEach(function (b) { b.disabled = on; });
  }

  function showChangeSheet(btn, d) {
    if (changing) return;
    closeSheet(true);
    sheetOpener = btn;
    var scope = btn.closest('cart-items') || document;
    d.inDrawer = !!btn.closest('cart-drawer');
    var cur = null, now = [], pre = [], out = [];
    d.variants.forEach(function (v) {
      if (v.id === d.variant) { cur = v; return; }
      var p = changePlan(d, v, scope);
      (p.kind === 'out' ? out : p.kind === 'pre' ? pre : now).push([v, p]);
    });
    var root = document.createElement('div');
    root.className = 'so-cart-addons-vd so-cart-change-vd';
    root.innerHTML =
      '<div class="so-vd__backdrop" data-close></div>' +
      '<div class="so-vd__drawer" role="dialog" aria-modal="true" tabindex="-1" aria-labelledby="so-cc-title">' +
      '<header class="so-vd__header"><div class="so-vd__header-text"><h2 class="so-vd__title" id="so-cc-title" tabindex="-1">Choose your ' + esc(d.option) + '</h2>' +
      '<p class="so-vd__summary">You have ' + d.qty + '</p></div>' +
      '<button type="button" class="so-vd__close" data-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg></button></header>' +
      (d.variants.length > 6 ? '<div class="so-vd__search-wrap"><input type="search" class="so-vd__search" placeholder="Search ' + esc(d.option) + '…" aria-label="Search ' + esc(d.option) + '" autocomplete="off"></div>' : '') +
      '<ul class="so-vd__list"></ul><p class="so-vd__noresults" hidden>No matches — try another search.</p></div>';
    var list = root.querySelector('.so-vd__list');
    function row(v, p, isCur) {
      var li = document.createElement('li');
      li.className = 'so-vd__row' + (isCur ? ' is-selected' : '') + (p && p.kind === 'pre' ? ' is-preorder' : '') + (p && p.kind === 'out' ? ' is-unavailable' : '') + (p && p.kind === 'low' ? ' is-lowstock' : '') + (p && p.kind === 'in' ? ' is-instock' : '');
      li.setAttribute('role', 'button');
      var dead = p && p.kind === 'out';
      li.tabIndex = dead ? -1 : 0;
      if (dead) li.setAttribute('aria-disabled', 'true');
      if (isCur) li.setAttribute('aria-current', 'true');
      var tag = isCur ? 'In your cart' : p.tag;
      li.innerHTML = '<span class="so-vd__thumb">' + (v.img ? '<img src="' + esc(v.img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="so-vd__thumb-fallback" aria-hidden="true"></span>') + '</span>' +
        '<span class="so-vd__row-text"><span class="so-vd__row-name">' + esc(v.title) + '</span><span class="so-vd__row-tag"' + (tag ? '' : ' hidden') + '>' + esc(tag) + '</span></span>' +
        '<span class="so-vd__row-check" aria-hidden="true"></span>';
      if (isCur) { li.addEventListener('click', function () { closeSheet(); }); li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeSheet(); } }); }
      else if (!dead) {
        var go = function () { runChange(btn, d, v, li); };
        li.addEventListener('click', go);
        li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      }
      list.appendChild(li);
    }
    function group(label, cls) { var g = document.createElement('li'); g.className = 'so-vd__group ' + cls; g.setAttribute('role', 'presentation'); g.textContent = label; list.appendChild(g); }
    if (cur) row(cur, null, true);
    if (now.length) { if (pre.length || out.length) group('Available now', 'so-vd__group--now'); now.forEach(function (x) { row(x[0], x[1]); }); }
    if (pre.length) { group('Pre-order' + soPreShip(), 'so-vd__group--pre'); pre.forEach(function (x) { row(x[0], x[1]); }); }
    if (out.length) { group('Currently unavailable', 'so-vd__group--un'); out.forEach(function (x) { row(x[0], x[1]); }); }
    var search = root.querySelector('.so-vd__search');
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase(), n = 0;
      list.querySelectorAll('.so-vd__row').forEach(function (li) { var hit = !q || li.querySelector('.so-vd__row-name').textContent.toLowerCase().indexOf(q) !== -1; li.hidden = !hit; if (hit) n++; });
      list.querySelectorAll('.so-vd__group').forEach(function (g) { g.hidden = !!q; });
      // keep pre-order visible without the headers
      list.querySelectorAll('.so-vd__row.is-preorder').forEach(function (li) { var t = li.querySelector('.so-vd__row-tag'); if (q && !t.textContent) { t.textContent = 'Pre-order' + soPreShip(); t.hidden = false; t.dataset.auto = '1'; } else if (!q && t.dataset.auto) { t.textContent = ''; t.hidden = true; delete t.dataset.auto; } });
      root.querySelector('.so-vd__noresults').hidden = n > 0;
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeSheet(); });
    document.body.appendChild(root);
    sheet = { root: root, drawer: root.querySelector('.so-vd__drawer'), backdrop: root.querySelector('.so-vd__backdrop') };
    swipe(sheet);
    document.documentElement.style.overflow = 'hidden';
    void sheet.drawer.offsetWidth;
    sheet.drawer.classList.add('is-open'); sheet.backdrop.classList.add('is-open');
    // Phones: don't pop the keyboard over the list — focus the heading; mouse devices get search.
    ((finePointer() && search) || root.querySelector('#so-cc-title')).focus({ preventScroll: true });
  }

  // Find THIS line in the Storefront cart: same variant AND same properties; the line number
  // only breaks a tie. If it can't be identified with certainty, refuse (never edit another line).
  function findLine(nodes, d) {
    // Liquid's `item.properties | json` gives [[key, value], …]; normalise to an object.
    var props = {};
    (Array.isArray(d.props) ? d.props : Object.keys(d.props || {}).map(function (k) { return [k, d.props[k]]; }))
      .forEach(function (kv) { if (kv[1] !== '' && kv[1] != null) props[kv[0]] = kv[1]; });
    var keys = Object.keys(props).sort();
    var same = nodes.filter(function (n) {
      if (n.merchandise.id !== gidV(d.variant)) return false;
      var a = {}; (n.attributes || []).forEach(function (x) { if (x.value !== '' && x.value != null) a[x.key] = x.value; });
      var ak = Object.keys(a).sort();
      return ak.length === keys.length && ak.every(function (k, i) { return k === keys[i] && a[k] === String(props[k]); });
    });
    if (same.length === 1) return same[0];
    var byPos = nodes[d.line - 1];
    if (same.length > 1 && same.indexOf(byPos) !== -1) return byPos;
    return null;
  }

  // Swap line d to variant v. li = tapped drawer row. undo = {qty} restores just this line.
  function runChange(btn, d, v, li, undo) {
    if (changing) return;
    setChanging(true);
    closeSheet(true);
    var card = btn.closest('.cart-item');
    var status = null;
    var verb = undo ? 'Changing back to ' : 'Changing to ';
    if (card) {
      card.classList.add('so-cart-change--busy');
      status = document.createElement('div');
      status.className = 'so-cart-change__done so-cart-change__working';
      status.tabIndex = -1;
      status.textContent = verb + v.title + '…';
      (card.querySelector('.cart-item__variants') || card.querySelector('.cart-item__details')).appendChild(status);
      btn.hidden = true;
      status.focus({ preventScroll: true });
    }
    announce(verb + v.title);
    var inDrawer = d.inDrawer !== undefined ? d.inDrawer : !!btn.closest('cart-drawer');
    var stale = false;
    var moved = null;
    cartToken().then(function (token) {
      var cartId = 'gid://shopify/Cart/' + token;
      return sf('query($id:ID!){cart(id:$id){lines(first:100){nodes{id quantity attributes{key value} merchandise{... on ProductVariant{id}}}}}}', { id: cartId }).then(function (data) {
        var nodes = data.cart ? data.cart.lines.nodes : [];
        var mine = findLine(nodes, d);
        if (!mine) { stale = true; throw STALE; }
        var myIdx = nodes.indexOf(mine) + 1;
        var lines, qty, merged = [];
        if (undo) {
          qty = undo.qty;
          lines = [{ id: mine.id, merchandiseId: gidV(v.id), quantity: qty }];
        } else {
          // Authoritative quantities from the live cart (not the DOM): all other lines of v merge in.
          nodes.forEach(function (n, i) { if (n !== mine && n.merchandise.id === gidV(v.id)) merged.push({ n: n, idx: i + 1 }); });
          var want = mine.quantity + merged.reduce(function (a, m) { return a + m.n.quantity; }, 0);
          qty = stockPlan(d, v, want).qty;
          lines = [{ id: mine.id, merchandiseId: gidV(v.id), quantity: qty }];
          merged.forEach(function (m) { lines.push({ id: m.n.id, quantity: 0 }); });
        }
        return sf('mutation($id:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$id,lines:$lines){userErrors{message}}}', { id: cartId, lines: lines })
          .then(function (res) {
            var errs = res.cartLinesUpdate.userErrors;
            if (errs.length) throw errs[0].message;
            // P0-12: the line's attribution (_so_src) follows it to the new flavour.
            if (window.SO && SO.cartSource) moved = SO.cartSource.moveTo(d.variant, v.id);
            var newIdx = myIdx - merged.filter(function (m) { return m.idx < myIdx; }).length;
            var msg = undo ? 'Changed back to ' + v.title
              : merged.length ? 'Combined with your other ' + v.title + ' · now ' + qty
              : 'Changed to ' + v.title + (qty !== mine.quantity ? ' · now ' + qty : '');
            var flash = { line: newIdx, text: msg };
            if (!undo && !merged.length) flash.undo = { variant: d.variant, qty: mine.quantity };
            try { sessionStorage.setItem(FLASH_KEY, JSON.stringify(flash)); } catch (e) {}
          });
      });
    }).then(function () {
      if (!inDrawer) { return Promise.resolve(moved).then(function () { window.location.reload(); }); }
      return Promise.resolve(moved).then(refreshDrawer).then(showFlash);
    }).catch(function (err) {
      var msg = typeof err === 'string' ? err : 'Something went wrong. Please try again.';
      announce(msg);
      if (stale && inDrawer) {
        try { sessionStorage.setItem(FLASH_KEY, JSON.stringify({ line: d.line, text: msg, error: true })); } catch (e) {}
        return refreshDrawer().then(showFlash);
      }
      if (stale) { try { sessionStorage.setItem(FLASH_KEY, JSON.stringify({ line: d.line, text: msg, error: true })); } catch (e) {} window.location.reload(); return; }
      if (card) card.classList.remove('so-cart-change--busy');
      if (status) { status.textContent = msg; status.classList.add('is-error'); }
      setTimeout(function () { if (status) status.remove(); btn.hidden = false; }, 5000);
    }).then(function () { setChanging(false); });
  }

  // Re-render the drawer from the server (the change bypassed the AJAX cart, so no sections came back).
  function refreshDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.renderContents) { window.location.reload(); return Promise.resolve(); }
    var sid = cd.closest('.shopify-section').id.replace('shopify-section-', '');
    return Promise.all([
      drawerHtml(sid),
      fetch(window.location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (res) {
      var sections = {}; sections[sid] = res[0];
      if (res[1] && res[1]['cart-icon-bubble']) sections['cart-icon-bubble'] = res[1]['cart-icon-bubble'];
      return cd.renderContents({ sections: sections }, false);
    }).then(function () { applyBasis(); });
  }

  // One quiet line on the changed card ("Changed to Guava · Undo"), scrolled into view, focus on
  // Undo, gone after 6s (focus back to "Change"). No toast.
  function showFlash() {
    var f; try { f = JSON.parse(sessionStorage.getItem(FLASH_KEY) || 'null'); sessionStorage.removeItem(FLASH_KEY); } catch (e) { f = null; }
    if (!f) return;
    // The /cart page also carries a (closed) drawer with the same #cart-item-N ids — prefer the visible list.
    var scope = document.querySelector('cart-drawer[open]') || document.querySelector('#cart') || document;
    var card = scope.querySelector('#cart-item-' + f.line);
    announce(f.text + (f.undo ? '. Undo button available.' : ''));
    if (!card) return;
    var host = card.querySelector('.cart-item__variants') || card.querySelector('.cart-item__details');
    var note = document.createElement('div');
    note.className = 'so-cart-change__done' + (f.error ? ' is-error' : '');
    note.innerHTML = '<span>' + esc(f.text) + '</span>' + (f.undo ? ' <button type="button" class="so-cart-change__undo">Undo</button>' : '');
    host.appendChild(note);
    if (!f.error) card.classList.add('so-cart-change--done');
    // Bring the card into view. In the drawer the list is its own scroller, it shrinks when the
    // pre-order choice appears in the footer, and the theme resets it after re-render — so centre
    // the card in that scroller explicitly, twice (after the theme's own layout pass).
    var scroller = card.closest('.drawer__content');
    function centre() {
      if (!card.isConnected) return;
      if (!scroller) { card.scrollIntoView({ block: 'center' }); return; }
      var cr = card.getBoundingClientRect(), sr = scroller.getBoundingClientRect();
      scroller.scrollTop += (cr.top - sr.top) - (scroller.clientHeight - Math.min(cr.height, scroller.clientHeight)) / 2;
    }
    centre(); setTimeout(centre, 120); setTimeout(centre, 450);
    var link = card.querySelector('[data-so-cart-change]');
    if (link) link.hidden = true;
    var undoBtn = note.querySelector('.so-cart-change__undo');
    if (undoBtn) {
      undoBtn.focus({ preventScroll: true });
      undoBtn.addEventListener('click', function () {
        var dj; try { dj = JSON.parse(card.querySelector('[data-so-cart-change-json]').textContent); } catch (e) { return; }
        var back = dj.variants.filter(function (x) { return x.id === f.undo.variant; })[0];
        if (!back || !link) return;
        dj.inDrawer = !!card.closest('cart-drawer');
        runChange(link, dj, back, null, { qty: f.undo.qty });
      });
    }
    setTimeout(function () {
      if (!note.isConnected) return;
      var hadFocus = note.contains(document.activeElement);
      note.remove(); card.classList.remove('so-cart-change--done');
      if (link && link.isConnected) { link.hidden = false; if (hadFocus) link.focus({ preventScroll: true }); }
    }, 6000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showFlash); else showFlash();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-so-cart-change]');
    if (!btn) return;
    e.preventDefault();
    var d; try { d = JSON.parse(btn.parentNode.querySelector('[data-so-cart-change-json]').textContent); } catch (err) { return; }
    showChangeSheet(btn, d);
  });
})();
